import { gql } from '@apollo/client'

const SEARCH_FUNDERS = gql`
  query SearchFunders(
    $id: Int
    $name: String
    $nonprofitName: String
    $cohortName: String
    $userEmail: String
    $limit: Int
    $offset: Int
  ) {
    searchFunders(
      id: $id
      name: $name
      nonprofitName: $nonprofitName
      cohortName: $cohortName
      userEmail: $userEmail
      limit: $limit
      offset: $offset
    ) {
      total
      funders {
        id
        name
        disabled
        isTest
        createdAt
        updatedAt
        disabledAt
        nonprofitOrgs {
          id
          name
        }
        cohorts {
          id
          name
        }
        users {
          id
          email
          firstName
          lastName
        }
      }
    }
  }
`

export default SEARCH_FUNDERS
